/**
 * @desc rollbackBatchNo
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.batchFacadeImpl.rollbackBatchNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/Batch/rollback/no`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
